import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Snackbar, Alert, AlertTitle,Box, Typography} from '@mui/material';
import { RootStateType } from '../../redux/features/rootSlice';

const NetworkToast = () => {
  const isOnline = useSelector((state: RootStateType) => state.networkStateReducer.isOnline);
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<'online' | 'offline'>('offline');
  const prevOnlineStatus = useRef(isOnline);

  useEffect(() => {
    if (prevOnlineStatus.current && !isOnline) {
      setStatus('offline');
      setOpen(true);
    } else if (!prevOnlineStatus.current && isOnline) {
      setStatus('online');
      setOpen(true);
    }
    prevOnlineStatus.current = isOnline;
  }, [isOnline]);

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };


  return (
    <>
    {open && (
    <div style={{ 
      position: 'fixed', 
      top: 0, left: 0, 
      width: '100%', height: '100%', 
      zIndex: 999999999, 
      backgroundColor: 'rgba(0,0,0,0.01)', 
      backdropFilter: 'grayscale(1)'}}>    
       <Snackbar
       open={open}
       autoHideDuration={status === 'offline' ? null : 3000}
       onClose={handleClose}
       anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
       >
       <Alert
        //  onClose={handleClose}
         severity={status === 'offline' ? 'error' : 'success'}
         variant="filled"
         sx={{
           width: '100%',
           minWidth: '350px',
           maxWidth: '550px',
           backgroundColor: status === 'offline' ? '#C62828' : '#2E7D32',
           color: '#fff',
           '& .MuiAlert-icon': {
             fontSize: '2.2rem',
             marginRight: '15px',
             color: '#fff', 
           },
           '& .MuiAlert-message': {
             width: '100%',
             padding: '8px 0',
             color: '#fff', 
           },
         }}
       >
         <Box>
           <AlertTitle sx={{ fontWeight: 700, fontSize: '1.15rem', m: 0,color: '#fff'  }}>
             {status === 'offline' ? 'You are currently offline.' : 'Connected!'}
           </AlertTitle>
         </Box>
       </Alert>
     </Snackbar>
    </div>
    )}
    
   
    </>
  );
};

export default NetworkToast;